
import { 
    DELETE_HOSPITAL,
    DELETE_HOSPITAL_SUCCESS,
    DELETE_HOSPITAL_FAIL, 
    DELETE_HOSPITAL_RESET,
} from "../actions/deleteHospitalAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const deleteHospitalReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_HOSPITAL:
            return {
                ...state,
                apiState: "loading",
            };
        case DELETE_HOSPITAL_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case DELETE_HOSPITAL_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case DELETE_HOSPITAL_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default deleteHospitalReducer;
